// I testi del sito, tutti qui: quelli che cambiano spesso (i piani, i
// prezzi, le battute di Pallino) si correggono in un posto solo, senza
// cercarli nel markup. La stesura approvata sta nella issue #186; il perché
// delle scelte in docs/sito.md.
//
// Il sito è guidato: chi arriva sceglie gli sport che insegna e se è un
// maestro o un circolo, e la pagina sotto cambia. Per questo quasi ogni
// testo qui ha due versioni, `maestro` e `circolo`.

export const CONTACT_EMAIL = "luca.morosini.1996@gmail.com"

export const SPORTS = [
	{ id: "tennis", name: "Tennis" },
	{ id: "padel", name: "Padel" },
	{ id: "pickleball", name: "Pickleball" },
]

export const ROLES = [
	{
		id: "maestro",
		title: "Insegno",
		text: "Ho i miei allievi, uno o più circoli, e un quaderno pieno di frecce.",
	},
	{
		id: "circolo",
		title: "Ho un circolo",
		text: "Ho dei maestri, dei campi, e qualcuno che a fine mese deve far tornare i conti.",
	},
]

export const RECOGNIZE = {
	maestro: {
		title: "La settimana di un maestro, prima di inCampo",
		items: [
			"Il quaderno delle lezioni, scritto a matita perché tanto cambia.",
			"«Ma martedì l'avevo pagata?», la domanda del venerdì sera.",
			"I recuperi, un'arte orale tramandata nel gruppo WhatsApp.",
			"L'Excel della domenica sera, che non torna mai al primo colpo.",
		],
	},
	circolo: {
		title: "Un mese tipo in segreteria",
		items: [
			"Il tabellone dei campi al muro, con tre colori di penna.",
			"«Chi ha spostato la lezione delle 18?» (nessuno, ovviamente).",
			"Le ore dei maestri da contare a fine mese, una per una.",
			"Gli allievi che pagano in segreteria, e le quote da girare ai maestri.",
		],
	},
}

// Ogni sezione ha il suo esempio (`demo`): uno dei tre dal vivo, o un
// disegno fermo. Pallino la presenta con una battuta (`say`) e una posa.
const FIELD = {
	id: "campo",
	nav: "Anche senza rete",
	kicker: "Fatta per stare in campo",
	title: "Anche sul campo 6",
	text: "Quello dove non arriva il Wi-Fi.",
	demo: "field",
	pose: "dorme",
	say: "La sera mi metto in scuro anch'io.",
}

export const SECTIONS = {
	maestro: [
		{
			id: "agenda",
			nav: "L'agenda",
			kicker: "Ore 8:30 · l'agenda",
			title: "La tua agenda, senza scarabocchi",
			text: "Il giorno o la settimana, con due dita. Le lezioni che si ripetono le segni una volta sola. Quelle negli altri circoli le vedi in trasparenza, così non ti prenoti in due posti alla stessa ora (succede, lo sappiamo). E finisce tutto su Google Calendar.",
			demo: "agenda",
			pose: "felice",
			say: "Io faccio il puntino sulla i. Tu pensa alle lezioni.",
		},
		{
			id: "corsi",
			nav: "Corsi e recuperi",
			kicker: "Ore 16:30 · i corsi",
			title: "Scuola tennis e corso adulti, senza fare l'appello",
			text: "Tocchi chi manca: l'assenza diventa un recupero, buono fino a fine stagione. Al suo posto può venire qualcun altro, e l'app ti propone chi ha un recupero da usare. Piove? Annulli per tutti in un colpo. Senza discussioni (quasi).",
			demo: "sub",
			pose: "fermo",
			say: "Chi manca lo segno io. Senza fare la spia.",
		},
		{
			id: "allievi",
			nav: "La scheda degli allievi",
			kicker: "Tra una lezione e l'altra",
			title: "Sai già dove va il rovescio di Marco. Adesso è anche scritto.",
			text: "La scheda tecnica di ogni allievo: il livello, che giocatore è, su cosa lavora. Gli allievi che hai già li porti da un foglio di calcolo.",
			demo: "sheet",
			pose: "fermo",
			say: "Il rovescio di Marco? Lo conosco bene: ci sono passato sotto.",
		},
		{
			id: "quaderno",
			nav: "Il programma e il quaderno",
			kicker: "La sera prima · il programma",
			title: "Il programma della lezione, con lo schema",
			text: "Le quattro fasi, gli obiettivi, gli esercizi col loro schema: giocatori, coni, la palla tesa o tonda. Quello che funziona va nel quaderno, con una variante per livello, e lo condividi coi colleghi del circolo: se domani ti sostituisce qualcuno, trova la lezione già pronta. Prova a disegnarne uno.",
			demo: "schema",
			pose: "felice",
			say: "Disegna pure le frecce. Tanto la palla sono io.",
		},
		{
			id: "conti",
			nav: "I conti del mese",
			kicker: "Il 31 del mese",
			title: "Conti fatti. Davvero.",
			text: "Ore, incassi, costo dei campi, quota da fatturare al circolo. Se a una lezione manca il pagamento, te lo dice prima che te ne dimentichi. I tuoi compensi li vedi solo tu.",
			demo: "month",
			pose: "felice",
			say: "Conti tondi. Come me.",
		},
		{
			id: "circoli",
			nav: "Più circoli",
			kicker: "Più circoli",
			title: "Insegni in tre circoli? Auguri. L'agenda però è una sola.",
			text: "Passi da un circolo all'altro con uno swipe, e ognuno tiene i suoi campi, i suoi prezzi e i suoi conti.",
			pose: "felice",
			say: "Rimbalzare da un circolo all'altro è il mio mestiere.",
		},
		FIELD,
	],
	circolo: [
		{
			id: "maestri",
			nav: "I maestri e i ruoli",
			kicker: "I tuoi maestri",
			title: "Un circolo, tanti maestri, un'agenda sola",
			text: "I maestri entrano con un codice. Tu decidi chi fa cosa: gestore, collega, osservatore, o un ruolo su misura. E quando in campo sono in due, la lezione va nel calendario di entrambi.",
			demo: "roles",
			pose: "felice",
			say: "Passo di mano in mano tutto il giorno. Qui almeno c'è un ordine.",
		},
		{
			id: "registro",
			nav: "Chi ha toccato cosa",
			kicker: "Chi ha toccato cosa",
			title: "Niente gialli in segreteria",
			text: "Ogni lezione dice chi l'ha creata e chi l'ha cambiata. Quelle eliminate restano in un registro, da cui si rimettono al loro posto.",
			demo: "log",
			pose: "fermo",
			say: "Non sono stato io. C'è scritto.",
		},
		{
			id: "corsi",
			nav: "Corsi e posti liberi",
			kicker: "I corsi",
			title: "Corsi pieni, anche quando qualcuno manca",
			text: "Assenze, recuperi e sostituti li gestiscono i maestri a bordo campo. Tu vedi i posti liberi dei prossimi sette giorni.",
			demo: "sub",
			pose: "fermo",
			say: "Chi manca lo segno io. Senza fare la spia.",
		},
		{
			id: "quaderno",
			nav: "Il quaderno del circolo",
			kicker: "Il quaderno del circolo",
			title: "Manca un maestro? La lezione no.",
			text: "Ogni maestro scrive il programma delle sue lezioni, con le fasi e lo schema di ogni esercizio, e lo condivide coi colleghi del circolo. Chi lo sostituisce trova la lezione pronta, per quel livello: i maestri si danno il cambio senza ripartire da zero. E chi se ne va può lasciare i suoi esercizi al circolo.",
			demo: "schema",
			pose: "felice",
			say: "Disegna pure le frecce. Tanto la palla sono io.",
		},
		{
			id: "conti",
			nav: "Campi e conti",
			kicker: "Campi e conti",
			title: "I conti tornano. Anche quelli del circolo.",
			text: "Campi, superfici, luce e riscaldamento. Gli allievi che pagano il circolo finiscono nella quota del circolo, e per ogni maestro sai quante ore e cosa fatturare.",
			demo: "month",
			pose: "felice",
			say: "Conti tondi. Come me.",
		},
		FIELD,
	],
}

// Le altre fermate di Pallino, dopo le sezioni: come le sezioni, `nav` per
// l'indice e `say` per il fumetto (quella dei prezzi la mette Landing.js da
// PRICES, perché cambia tra maestro e circolo)
export const GUIDE_STOPS = [
	{ id: "prezzi", nav: "Quanto costa" },
	{ id: "chi-sono", nav: "Chi sono", say: "Lui è Luca. Mi ha disegnato lui." },
	{ id: "domande", nav: "Domande", say: "Domande? Le risposte le ho io. Quasi tutte." },
]

export const FIELD_ITEMS = [
	{ title: "Senza rete", text: "Segni lo stesso: l'app manda tutto appena torna la linea." },
	{ title: "Tema scuro", text: "La sera passa allo scuro da sola, come te." },
	{ title: "I tuoi dati", text: "Sono tuoi, e li scarichi quando vuoi." },
	{ title: "Qualcosa non va?", text: "Lo segnali dall'app, in due righe." },
]

// I piani: prezzi di lancio, provvisori (la bozza è di Luca). Si cambiano
// qui e basta.
const YEAR_NOTE = {
	title: "L'anno costa dieci mesi",
	text: "D'estate la scuola si ferma: chi paga l'anno non paga luglio e agosto.",
}

export const PRICES = {
	maestro: {
		say: "Costo meno di un tubo di palline. E duro di più.",
		title: "Due mesi gratis. Poi meno di un tubo di palline al mese.",
		lead: "La prova ha tutto dentro. Dopo scegli in base a come lavori: solo private, o anche corsi.",
		plans: [
			{
				name: "Prova",
				who: "Per provarla coi tuoi allievi",
				amount: "0 €",
				year: "per 60 giorni",
				limits: [
					["60 giorni", "di prova"],
					["tutto", "di Maestro Plus"],
				],
				plus: "Tutto incluso:",
				features: [
					"Lezioni private e corsi",
					"Pagamenti, assenze e recuperi",
					"Quaderno di lezioni ed esercizi",
					"Google Calendar",
				],
			},
			{
				name: "Maestro",
				who: "Per chi fa lezioni private",
				amount: "6 €",
				per: "/ mese",
				year: "oppure 60 € l'anno",
				pick: true,
				limits: [
					["1", "circolo"],
					["illimitati", "allievi"],
				],
				features: [
					"Agenda, giorno e settimana",
					"Pagamenti degli allievi e conti",
					"Quaderno di lezioni ed esercizi",
					"Google Calendar",
					"Funziona anche senza rete",
				],
			},
			{
				name: "Maestro Plus",
				who: "Per chi ha i suoi corsi",
				amount: "12 €",
				per: "/ mese",
				year: "oppure 120 € l'anno",
				limits: [
					["illimitati", "circoli"],
					["illimitati", "allievi"],
				],
				plus: "Tutto di Maestro, più:",
				features: [
					"Corsi in abbonamento",
					"Assenze, recuperi e posti liberi",
					"Tipologie di corso tue",
					"Più circoli",
				],
			},
		],
		notes: [
			YEAR_NOTE,
			{ title: "Nessuno paga due volte", text: "Se il circolo paga, tu lì dentro no." },
			{
				title: "Niente si perde",
				text: "Se il piano scade passi in sola lettura. I dati li scarichi sempre gratis.",
			},
			{ title: "Sei già dentro?", text: "Chi usa già l'app: 6 mesi gratis e prezzo bloccato." },
		],
	},
	circolo: {
		say: "Tutto il circolo costa molto meno di un cesto di palline. E non finisce oltre la recinzione.",
		title: "Paga il circolo, e i suoi maestri non pagano niente.",
		lead: "Un prezzo solo per tutti i maestri del circolo, in base a quanti sono: al mese, molto meno di un cesto di palline.",
		plans: [
			{
				name: "Circolo",
				who: "Per il circolo con pochi maestri",
				amount: "32 €",
				per: "/ mese",
				year: "oppure 320 € l'anno",
				pick: true,
				limits: [
					["fino a 3", "maestri attivi"],
					["illimitati", "allievi"],
				],
				plus: "Tutto di Maestro Plus per ogni maestro, più:",
				features: [
					"Colleghi e gestori, entrano con un codice",
					"Lezioni affidate e assistenti in campo",
					"Listino comune e tipologie del circolo",
					"Proposte per il sostituto",
				],
			},
			{
				name: "Circolo Grande",
				who: "Per le scuole grandi",
				amount: "69 €",
				per: "/ mese",
				year: "oppure 690 € l'anno",
				limits: [
					["da 4 a 15", "maestri attivi"],
					["illimitati", "allievi"],
				],
				plus: "Tutto di Circolo, con più maestri.",
				features: ["Oltre 15 maestri: prezzo su richiesta"],
			},
			{
				name: "Più sedi",
				who: "Per gruppi e accademie",
				amount: "Su richiesta",
				year: "−20% dal secondo circolo",
				limits: [
					["2 o più", "circoli"],
					["1", "fattura sola"],
				],
				plus: "Il piano Circolo per ogni sede, con:",
				features: ["Una fattura sola per tutte le sedi", "Il 20% in meno dal secondo circolo"],
			},
		],
		notes: [
			YEAR_NOTE,
			{
				title: "Maestro attivo",
				text: "Chi ha almeno una lezione sua nel mese. Chi fa solo l'assistente non conta.",
			},
			{
				title: "Niente si perde",
				text: "Se il piano scade passi in sola lettura. I dati si scaricano sempre gratis.",
			},
			{ title: "Circoli fondatori", text: "Chi usa già l'app: 6 mesi gratis e prezzo bloccato." },
		],
	},
}

const FAQ_COMMON = [
	{
		q: "Va scaricata dallo store?",
		a: "No: si apre dal browser e si aggiunge alla schermata Home. Da lì in poi sembra un'app, perché lo è.",
	},
	{ q: "Funziona su iPhone e Android?", a: "Sì, su tutti e due, e anche al computer." },
	{ q: "Posso portare i miei allievi?", a: "Sì, da un foglio di calcolo, tutti insieme." },
	{
		q: "I miei dati?",
		a: "Tuoi. Li scarichi quando vuoi, e i compensi li vede solo chi li incassa.",
	},
]

export const FAQ = {
	maestro: [
		{
			q: "Quanto costa?",
			a: "I primi 60 giorni sono gratis, con tutto dentro. Poi da 6 € al mese, e l'anno costa dieci mesi.",
		},
		...FAQ_COMMON,
		{
			q: "E se insegno in un circolo che non usa inCampo?",
			a: "Nessun problema: le lezioni lì le segni lo stesso, coi tuoi conti.",
		},
	],
	circolo: [
		{
			q: "Quanto costa?",
			a: "Da 32 € al mese per tutto il circolo, e i maestri lì dentro non pagano niente.",
		},
		...FAQ_COMMON,
		{
			q: "Possiamo provarlo prima?",
			a: "Sì: si comincia gratis, oppure ne parliamo e ve lo prepariamo.",
		},
	],
}

export const CLOSING = {
	maestro: "Pronto a mandare in pensione il quaderno a matita?",
	circolo: "Il tabellone in segreteria può andare in pensione.",
}
